export default __webpack_public_path__ + "static/media/404.b0b48246.svg";